import React from 'react';
import Paper from "@mui/material/Paper";
import {ClickAwayListener, Popper} from "@mui/material";
import UserInfo from "./UserInfo";
import uiStore from "../../lib/stores/uiStore";
import {observer} from "mobx-react";

const PopperUserInfo = () => {
    return <Popper
            sx={{
                maxHeight: "300px",
            }}
            modifiers={[
                {
                    name: "offset",
                    options: {
                        offset: [0, 5],
                    },
                },
            ]}
            open={uiStore.userInfoVisible}
            anchorEl={uiStore.userInfoView?.userAnchorEl?.current}
            role={undefined}
            placement={uiStore.userInfoView?.userInfoPlacement}
    >
        <Paper
                elevation={4}
        >
            <ClickAwayListener onClickAway={() => {
                uiStore.userInfoVisible = false;
            }}>
                <UserInfo user={uiStore.userInfoView?.selectedUser}/>
            </ClickAwayListener>
        </Paper>
    </Popper>
};

export default observer(PopperUserInfo);
